/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
import { ClipboardDirective } from "./clipboard.directive";
import { CLIPBOARD_SERVICE_PROVIDER } from "./clipboard.service";
import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { WindowTokenModule } from "ngx-window-token";
export { ClipboardDirective } from "./clipboard.directive";
export { ClipboardService, CLIPBOARD_SERVICE_PROVIDER_FACTORY, CLIPBOARD_SERVICE_PROVIDER } from "./clipboard.service";
var ClipboardModule = (function () {
    function ClipboardModule() {
    }
    ClipboardModule.decorators = [
        { type: NgModule, args: [{
                    imports: [CommonModule, WindowTokenModule],
                    // tslint:disable-next-line:object-literal-sort-keys
                    declarations: [ClipboardDirective],
                    exports: [ClipboardDirective],
                    providers: [CLIPBOARD_SERVICE_PROVIDER]
                },] },
    ];
    /** @nocollapse */
    ClipboardModule.ctorParameters = function () { return []; };
    return ClipboardModule;
}());
export { ClipboardModule };
function ClipboardModule_tsickle_Closure_declarations() {
    /** @type {!Array<{type: !Function, args: (undefined|!Array<?>)}>} */
    ClipboardModule.decorators;
    /**
     * @nocollapse
     * @type {function(): !Array<(null|{type: ?, decorators: (undefined|!Array<{type: !Function, args: (undefined|!Array<?>)}>)})>}
     */
    ClipboardModule.ctorParameters;
}
//# sourceMappingURL=ngx-clipboard.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/ngx-clipboard/dist/src/ngx-clipboard.js
// module id = ./node_modules/ngx-clipboard/dist/src/ngx-clipboard.js
// module chunks = tableDemo.module